/**
 * i18n 引导入口
 *
 * 必须在 main.ts 最顶部 import，使得在任何业务模块（router / store / 组件）
 * 首次取值 this.$t() 之前，locale 已被解析并应用到 vue-i18n 实例。
 */

import { i18n, applyElementLocale } from './index';
import { resolveLocale, STORAGE_KEY } from './resolver';

const initialLocale = resolveLocale('AUTO_INIT');
i18n.locale = initialLocale;
// 同步初始化 Element-UI 内建文案 locale，必须早于 '@/plugins' 注册 Element 组件。
applyElementLocale(initialLocale);
try { localStorage.setItem(STORAGE_KEY, initialLocale); } catch { /* ignore */ }

// CSS ::before/::after content 无法直接调用 $t，所以把需要国际化的伪元素文本
// 写成 CSS 变量挂到 :root 上，locale 切换后 switchLocale.ts 会 reload，此文件重跑。
try {
  const label = i18n.t('views.wheeloffortune.wheel_countdown_label') as string;
  document.documentElement.style.setProperty('--wheel-countdown-label', `"${label.replace(/"/g, '\\"')}"`);
} catch { /* ignore */ }
